// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zXaZ5","newExpiryDate":"styles_newExpiryDate__TYCHN","footer":"styles_footer__3TJmh"};